import { List, Map } from 'immutable';

import { closeDialogType, removeDialogType, updateDialogType } from './DialogsConstants';

export const initialState = Map({
  dialogs: Map(),
  dialogsIds: List(),
});

// eslint-disable-next-line default-param-last
export default function dialogsReducer(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case updateDialogType: {
      const { id } = payload;

      return state
        .update('dialogsIds', (ids) => {
          if (state.hasIn(['dialogs', id])) {
            return ids;
          }

          return ids.push(id);
        })
        .updateIn(['dialogs', id], (info) => {
          if (!info) {
            return payload;
          }

          return {
            ...info,
            ...payload,
          };
        });
    }

    case closeDialogType: {
      const { id } = payload;

      if (!state.hasIn(['dialogs', id])) {
        return state;
      }

      return state.updateIn(['dialogs', id], (info) => ({
        ...info,
        closed: true,
      }));
    }
    case removeDialogType: {
      const { id } = payload;

      if (!state.hasIn(['dialogs', id])) {
        return state;
      }

      return state.deleteIn(['dialogs', id]).update('dialogsIds', (ids) => {
        const index = ids.findIndex((i) => i === id);
        return ids.delete(index);
      });
    }

    default: {
      return state;
    }
  }
}
